import { Model } from 'modules/core/lib/mobx-rest'

interface IPresence {
  employee_id: string
  clocked_in: boolean
  on_break: boolean
}

class Presence extends Model<IPresence> {
  static urlRoot() {
    return '/attendance/presences'
  }

  static getNull(employeeId: string): Presence {
    return new Presence({
      employee_id: employeeId,
      clocked_in: false,
      on_break: false,
    })
  }

  get primaryKey(): string {
    return 'employee_id'
  }
}

export default Presence
